<template>
    <header class="o-header" ref="theHeader" v-bind:style="{width : theCurrentHeaderWidth, position : theCurrentHeaderPosition}">
        <div class="o-menu__icon-mob" @click="updateMobileMenu"></div>
        <div class="flex-grid flex-grid--reduced-bottom-margin flex-state-buttons u-full-width u-flex-direction-row u-r-flex-start">
            <div class="a-logo-image">
                <h1>
                    <svg viewBox="0 0 400 53.8">
                        <use xlink:href="#logo"></use>
                    </svg>
                </h1>
            </div>
            <div class="flex-grid flex-grid--reduced-bottom-margin o-header__right">
                <div class="o-header__button-container">
                    <div v-if="saveButton" :class="[saving() ? 'a-loader--save-claim':'']"></div>
                    <button v-if="saveButton && !saving()"
                            class="a-button a-button--header-button"
                            :disabled="current && !current.valid"
                            @click="saveForm">Save Claim</button>
                    <button v-if="loadButton" class="a-button a-button--header-button u-margin-left-10" @click="force">Load Claim</button>
                    <create-a-new-claim></create-a-new-claim>
                </div>
                <div class="o-header__bc-logo u-r-margin-left-20">
                    <span>created by:</span>
                    <svg viewBox="0 0 185 52">
                        <use xlink:href="#bc-logo"></use>
                    </svg>
                </div>
            </div>
        </div>
        <div :class="{'o-header__line' : setBorder}"></div>
    </header>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';
    import dropdown from 'components/dropdown/Dropdown.vue';
    import Icons from 'components/Icons.vue';
    import CreateANewClaim from 'components/dropdown/CreateANewClaim.vue';

    export default {
        name: 'header-section',
        components: {dropdown, Icons, CreateANewClaim},
        computed: {
            ...mapGetters('menu', ['isMenuOpen', 'isMobileMenuOpen', 'isMenuCollapsed']),
            ...mapGetters('windowWidth', ['theCurrentWidth']),
            ...mapGetters('headerWidth', ['theCurrentHeaderWidth', 'theCurrentHeaderPosition']),
            ...mapGetters('http', ['running']),
        },
        props: {
            title: {
                type: String,
                default: ''
            },
            loadButton: {
                type: Boolean,
                default: false
            },
            saveButton: {
                type: Boolean,
                default: false
            },
            createButton: {
                type: Boolean,
                default: false
            },
            setBorder: {
                type: Boolean,
                default: false
            },
            setPosition: {
                type: String,
                default: 'relative'
            },
            setWidth: {
                type: String,
                default: '80'
            },
            current: {
                type: Object,
                default: () => {}
            }
        },
        methods: {
            ...mapActions('dropdown', ['toggle']),
            ...mapActions('menu', ['updateMenu', 'updateMobileMenu', 'updateSubMenu']),
            ...mapActions('fatal', {resetFatal: 'reset'}),
            ...mapActions('claim', ['reset', 'initialise', 'save']),
            ...mapActions('fatal/interimPayments', {resetInterimPayments: 'reset'}),
            ...mapActions('windowWidth', ['updateWidth']),
            ...mapActions('headerWidth', ['updateHeaderWidth', 'updateHeaderPosition', 'setInitialHeaderWidth', 'setInitialHeaderPosition']),
            isRoute(route) {
                return !!this.$route.matched.filter(function (matched) {
                    return matched && (matched.path.indexOf(route) !== -1 || matched.name === route);
                }).length;
            },
            isInRoutePath(routeName) {
                return ~this.$route.path.indexOf(routeName)
            },
            force() {
                this.updateMenu(false);
                this.updateSubMenu(null);
                this.forceMenu = true;
                this.$router.push({name: 'claims'});
            },
            saveForm() {
                if (!this.current || !this.current.valid) {
                    return;
                }

                this.save(this.current.step - 1);
            },
            saving() {
                return this.running;
            },
        },
        mounted() {
            this.updateWidth(window.innerWidth);
            this.setInitialHeaderWidth({initialWidthValue: this.setWidth});
            this.setInitialHeaderPosition({initialPositionValue: this.setPosition});
            this.updateHeaderWidth({windowWidth: this.theCurrentWidth});
            this.updateHeaderPosition({windowWidth: this.theCurrentWidth});
        }
    }
</script>


// WEBPACK FOOTER //
// Header.vue?f9c595ba